import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomSelect from '../../common/formElements/CustomSelect';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomLoader from '../common/CustomLoader';
import fieldOptions from './FieldOptionsData';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import CustomRadio from '../../common/ui/CustomRadio';
import AlertMessageBox from '../../common/ui/AlertMessageBox';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class XanoEditPage extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    fieldDatatypes: [],
    upid: null,
  };

  async componentDidMount() {
    const { match, location } = this.props;
    const { projectId, version, dbUuid } = match.params;
    const { collectionobj, getdata } = location.state;
    const { completeData, setting, uuid } = getdata;
    this.setState({ upid: uuid });
    const { id } = collectionobj;
    this.props.actions.xanoSchema({
      token: setting.xanoApiAccessToken,
      workspaceId: completeData.workspace.id,
      idcol: id,
      projectId,
      version,
    });
  }

  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0].name] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };

  handleUpdateSubmit = async (values, selectedPrimaryKey) => {
    const { collectionobj, getdata } = this.props.location.state;
    const { name, id } = collectionobj;
    const { completeData, setting, uuid } = getdata;
    const { workspace } = completeData;
    const { getXanoSchemaData } = this.props.dataConnector;
    const { fieldDatatypes, upid } = this.state;
    const newArray = getXanoSchemaData.filter((element, index) => {
      if (index !== 0 && index !== 1) {
        return element;
      }
    });
    const result = {};
    newArray.forEach((item) => {
      const fieldValue = fieldDatatypes[item.name] || (item.type === 'int' ? 'number' : item.type);
      result[item.name] = fieldValue;
    });
    const newresult = {};
    for (const key in result) {
      if (result.hasOwnProperty(key)) {
        newresult[key] = result[key] === 'int' ? 'number' : result[key];
      }
    }
    const { projectId, dbUuid, version } = this.props.match.params;
    const savefieldsobj = {
      collectionTitle: values.collectionTitle,
      fieldsToUpdate: newresult,
      objectIdToUpdate: id,
      externalDbUuid: dbUuid,
      selectedPrimaryKey,
    };
    await this.props.actions.saveXanoFields({ savefieldsobj, projectId, upid, version });
    const dataforupdate = {
      collectionTitle: values.collectionTitle,
      orgCollectionName: name,
      collectionNames: name,
      fields: newresult,
      projectId,
      externalDatabaseId: dbUuid,
      collectionId: id,
      databaseId: workspace.id,
      // setting: {
      //   developer_key: setting.xanoApiAccessToken,
      // },
      setting,
      name: getdata ? getdata.name : '',
      selectedPrimaryKey,
    };
    const res = await this.props.actions.xanoUpdateCollection({
      dataforupdate,
      projectId,
      version,
    });
    if (res) {
      this.props.history.push(
        `/data-connector/${version}/v/${projectId}/external-database-edit/${dbUuid}`,
      );
    }
  };
  handleCancel = () => {
    const { projectId, dbUuid, version } = this.props.match.params;
    this.props.history.push(
      `/data-connector/${version}/v/${projectId}/external-database-edit/${dbUuid}`,
    );
  };
  showAlertMessage = () => {
    return (
      <AlertMessageBox
        type="info"
        text={`Note: If no primary key is selected below, the system will default to using the 
<strong>'id'</strong> field as the primary key for External APIs.`}
      />
    );
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { getXanoSchemaData, xanoSchemaPending } = this.props.dataConnector;
    const { collectionobj } = this.props.location.state;
    const { name, collectionTitle, selectedPrimaryKey } = collectionobj;
    const filterFields = (fields) => {
      return fields.filter((header) => header.name !== 'id' && header.name !== 'created_at');
    };
    if (xanoSchemaPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader loading={xanoSchemaPending} size="20px" color="#303453" />
          </div>
        </CommonPageComponent>
      );
    }

    return (
      <CommonPageComponent>
        <ParentContentCard title="Choose This Collection for Update" icon="collection">
          <Formik
            initialValues={{ collectionTitle: collectionTitle || name }}
            enableReinitialize={true}
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-6 col-lg-11 col-sm-8 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Xano collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={name}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                      value={name}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                        value={values.collectionTitle}
                        onChange={(e) => setFieldValue('collectionTitle', e.target.value)}
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  {this.showAlertMessage()}
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Fields</th>
                          <th>Types</th>
                          {selectedPrimaryKey && selectedPrimaryKey != 'id' && (
                            <th style={{ width: '12%' }}>Primary Key</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {filterFields(getXanoSchemaData).map((header, index) => (
                          <tr key={index}>
                            <td>{header.name}</td>
                            <td>
                              <CustomSelect
                                name={header}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={this.handleFieldChange}
                                options={fieldOptions}
                                value={this.state.fieldDatatypes[header.name] || header.type}
                              />
                            </td>
                            {selectedPrimaryKey !== 'id' && (
                              <td style={{ width: '12%' }}>
                                {selectedPrimaryKey ? (
                                  <div className="form-check ml-4 pl-3">
                                    <CustomRadio label="" isRadio={false}>
                                      <Field
                                        type="checkbox"
                                        name={header}
                                        className="form-check-input"
                                        checked={selectedPrimaryKey === header.name ? true : false}
                                        disabled={selectedPrimaryKey === header.name ? false : true}
                                      />
                                    </CustomRadio>
                                  </div>
                                ) : (
                                  <div className="form-check ml-4 pl-3">
                                    <CustomRadio label="" isRadio={false}>
                                      <Field
                                        type="checkbox"
                                        name={header}
                                        className="form-check-input"
                                        checked={selectedPrimaryKey === header.name ? true : false}
                                        disabled={selectedPrimaryKey === header.name ? false : true}
                                      />
                                    </CustomRadio>
                                  </div>
                                )}
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Skip"
                      type="button"
                      onClick={this.handleCancel}
                    >
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md ml-3"
                      title="Save Collection"
                      onClick={() => this.handleUpdateSubmit(values, selectedPrimaryKey)}
                    >
                      <i className="wb webconnect-save-regular"></i> Update
                      <CustomLoader loading={xanoSchemaPending} />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XanoEditPage);
